import ReactStorage from './reactStorage';
import { StorageInterface } from './storage';

const storageManager: StorageInterface = ReactStorage;

export default storageManager;
